var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-popover",
        {
          staticStyle: { padding: "12px 0" },
          attrs: {
            placement: "bottom-start",
            trigger: "click",
            "append-to-body": false,
            "popper-class": "tree-popper"
          },
          on: { hide: _vm.popoverHide },
          model: {
            value: _vm.isShowSelect,
            callback: function($$v) {
              _vm.isShowSelect = $$v
            },
            expression: "isShowSelect"
          }
        },
        [
          _c("el-input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowFilter,
                expression: "isShowFilter"
              }
            ],
            attrs: { placeholder: "输入关键字进行过滤" },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          }),
          _vm._v(" "),
          _c("el-tree", {
            ref: "selectTree",
            staticClass: "common-tree",
            attrs: {
              data: _vm.data,
              props: _vm.defaultProps,
              "show-checkbox": _vm.multiple,
              "node-key": _vm.nodeKey,
              "check-strictly": _vm.checkStrictly,
              "default-expand-all": _vm.defaultExpandAll,
              "filter-node-method": _vm.filterNode,
              "expand-on-click-node": _vm.expandOnClickNode,
              "check-on-click-node": _vm.multiple,
              "highlight-current": true
            },
            on: {
              "node-click": _vm.handleNodeClick,
              "check-change": _vm.handleCheckChange
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              ref: "select",
              staticClass: "tree-select",
              attrs: {
                slot: "reference",
                multiple: _vm.multiple,
                placeholder: _vm.placeholder,
                clearable: _vm.clearable,
                "collapse-tags": _vm.collapseTags
              },
              on: {
                "remove-tag": _vm.removeSelectedNodes,
                clear: _vm.removeSelectedNode,
                change: _vm.changeSelectedNodes
              },
              slot: "reference",
              model: {
                value: _vm.selectedData,
                callback: function($$v) {
                  _vm.selectedData = $$v
                },
                expression: "selectedData"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.value,
                staticClass: "tree-select__option",
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa8e2b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa8e2b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXForm/EXSelectTree.vue
// module id = 451
// module chunks = 0